module.exports = __webpack_public_path__ + "571c1414f8917acf4c3e9257a2f5a19e.png";